import service from '@/utils/request';
export var getChannelPullUpTime = function getChannelPullUpTime() {
  return service({
    url: '/common/getChannelPullUpTime',
    method: 'post'
  });
};